import template from './versions-show.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($mdDialog, $log, version) {
	var vm = this
	vm.$onInit = () => {
		//API methods
		vm.cancel = cancel

		//Scope attributes
		vm.version = version
		vm.title = vm.version.name

		activate()
		function activate() {}

		function cancel() {
			close()
		}

		function close() {
			$mdDialog.cancel()
		}
	}
}
